import { Component, EventEmitter, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { StorageKeys } from "src/app/shared/enums/storage-keys";
import { ICookies } from "../../interfaces/icookies";
import { CookieDialogComponent } from "./cookie-dialog/cookie-dialog.component";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { filter, tap } from "rxjs";
import { AlertService } from "src/app/b2b/ops/shared/services/alert.service";
import { Button } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "v-cookie-consent",
  templateUrl: "./cookie-consent.component.html",
  styleUrls: ["./cookie-consent.component.scss"],
  imports: [FormsModule, Button],
})
export class CookieConsentComponent {
  @Output() public accept: EventEmitter<boolean>;

  public constructor(private readonly alertService: AlertService) {
    this.accept = new EventEmitter<boolean>();
  }

  public acceptCookies() {
    this.accept.emit(true);
    this.setCookieSettings(true);
    location.reload();
  }

  public modalOpen(showPolicy: boolean) {
    const ref = this.alertService.customDialog(CookieDialogComponent, {
      data: { showPolicy },
      styleClass: "cybera-dialog-lg",
      showHeader: false,
      style: { padding: "4px" },
      contentStyle: { padding: "0px" },
    });

    ref.onClose
      .pipe(
        untilDestroyed(this),
        filter((val: boolean | undefined) => val !== undefined),
        tap((val: boolean) => this.setCookieSettings(val)),
      )
      .subscribe();
  }

  private setCookieSettings(isPerformanceCookie: boolean) {
    localStorage.setItem(
      StorageKeys.cookiesConsent as string,
      JSON.stringify({
        necessary: true,
        performanceAndAnalytics: isPerformanceCookie,
        cookiesConsent: true,
      } as ICookies),
    );
  }
}
